import React from 'react';
import {
  Wrapper,
  HtmlContent,
  CaptionedPhoto,
} from '../common';
import { toKebabCase } from '../../util/helpers';
import './TeamBlock.scss';

const TeamBlock = (props) => {
  const {
    data,
  } = props;
  const {
    primary,
    items: teamMembers,
  } = data;
  const {
    title,
  } = primary;
  return (
    <section className="team-block">
      <Wrapper isBound>
        <h2 className="title">{title.text}</h2>
        <div className="team-members">
          { teamMembers && teamMembers.map((teamMember) => {
            const {
              frameColour,
              imageStyle,
              name,
              photo,
              position,
              shortBio,
              speechBubbleText,
            } = teamMember;
            return (
              <div
                className="team-member"
                key={toKebabCase(name.text)}
              >
                <CaptionedPhoto
                  photo={photo}
                  isSquare={imageStyle.toLowerCase() === 'square'}
                  isPortrait={imageStyle.toLowerCase() === 'portrait'}
                  hasFrame
                  frameColour={frameColour}
                  photoCaption={speechBubbleText && speechBubbleText.text ? speechBubbleText.text : null}
                />
                <h3 className="name">{name.text}</h3>
                <span className="position">{position.text}</span>
                <HtmlContent content={shortBio.html} />
              </div>
            );
          })}
        </div>
      </Wrapper>
    </section>
  );
};

export default TeamBlock;
